import { useAuth } from "../../contexts/UserContext";

import {useEffect, useState} from "react";

// Hooks
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { useMetaDescription } from "../../hooks/useMetaDescription";
import api from "../../services/api";
import NotificationCard from "../../components/Ui/NotificationCard";
import {Paginate} from "../Proposals/styles";
import ReactPaginate from "react-paginate";
import {IconAdvancePagination, IconBackPagination, IconEyeOpen} from "../../components/icons";
import {comum} from "../../styles/Themes/light";
import {Oval} from "react-loader-spinner";
import ButtonIcon from "../../components/form/ButtonIcon";
import {Container} from "./styles";

export default function Notifications() {
    // Define o título e meta description da página
    useDocumentTitle({ title: "Notificações" });
    useMetaDescription({ 
        description: "Gerencie suas notificações na EasyJur Legal Ops. Acompanhe atualizações de demandas, propostas e sistema." 
    });

    const { setPageName, setPageType } = useAuth();
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ notifications, setNotifications ] = useState<any>();
    const [ notificationsPagination, setNotificationsPagination ] = useState<any>();

    async function visualizarTodasNotificacoes()
    {
        await api.post(`/notificacoes/visualizar-todas`)
        loadNotifications().then()
        window.dispatchEvent(new Event('refreshCounters'));
    }

    async function loadNotifications(page=1)
    {
        setLoading(true)
        const response = await api.get('notificacoes?page='+page);
        setNotifications(response.data.result.data);
        setNotificationsPagination(response.data.result.pagination);
        setLoading(false)
    }

    const onClickPage = (name: any, selectedItem: { selected: number; }) => {

        let pageNumber = selectedItem.selected + 1
        loadNotifications(pageNumber).then();

    }

    useEffect( () => {
        setPageName('Notificações')
        setPageType('normal');

        loadNotifications().then();

    }, []);

    return (
        <Container>
            {
            <ButtonIcon
                Icon={<IconEyeOpen color='#ffffff' />}
                children={'Marcar Todas como Lida'}
                styles="op"
                onClick={visualizarTodasNotificacoes}
            />
            }
            {
                loading &&
                <Oval
                    height={150}
                    width={150}
                    color={comum.colors.primaryRed400}
                    wrapperStyle={{}}
                    wrapperClass="loader"
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor={comum.colors.primaryRed400}
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                />
            }
            {
                notifications?.length > 0 &&
                notifications?.map((row: any) => (
                    <NotificationCard
                        reload = {() => loadNotifications()}
                        notification={row}
                        key={row.id}
                    />
                ))
            }

            {
                notifications?.length < 1 &&
                <div className="zero">Sem notificações disponíveis no momento.</div>
            }

            <Paginate>
                <ReactPaginate
                    breakLabel="..."
                    nextLabel={<IconAdvancePagination color={comum.colors.interfaceTextGray}/>}
                    previousLabel={<IconBackPagination color={comum.colors.interfaceTextGray}/>}
                    onPageChange={(value) => onClickPage('waiting', value)}
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    pageCount={notificationsPagination?.lastPage}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="back-page"
                    previousLinkClassName="back-link-page"
                    nextClassName="next-page"
                    nextLinkClassName="next-link-page"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    activeLinkClassName="active"
                />
            </Paginate>

        </Container>
    )
}
